import * as types from './index';


export const clientListAction = (data) => {
    return {
    type: types.CLIENT_LIST,
    data
    }
};

export const clientQuickAddAction = (data) => {
    return {
    type: types.CLIENT_QUICK_ADD,
    data
    }
};


export const clientCompanyInfoAddAction = (data) => {
    return {
    type: types.CLIENT_CMPNY_INFO_ADD,
    data
    }
};

export const clientPrmryCntAddAction = (data) => {
    return {
    type: types.CLIENT_PRMRY_CNCT_ADD,
    data
    }
};

export const clientCompanyInfoUpdateAction = (data) => {
    return {
    type: types.CLIENT_CMPNY_INFO_UPDATE,
    data
    }
};

export const clientPrmryCntUpdateAction = (data) => {
    return {
    type: types.CLIENT_PRMRY_CNCT_UPDATE,
    data
    }
};

export const clientEditAction = (data) => {
    return {
    type: types.CLIENT_EDIT,
    data
    }
};

export const clientActiveDeactiveAction = (data) => {
    return {
    type: types.CLIENT_ACTIVE_DEACTIVE,
    data
    }
};

export const clientContactListAction = (data) => {
   return {
    type: types.CLIENT_CONTACT_LIST,
    data
   }
}

export const clientContactAddAction = (data) => {
    return {
    type: types.CLIENT_CONTACT_ADD,
    data
    }
};

export const clientProfileRateCardListAction = (data) => {
    return {
    type: types.CLIENT_RATE_CARD_LIST,
    data
    }
};

export const clientProfileRateCardUpdateAction = (data) => {
    return {
    type: types.CLIENT_RATE_CARD_UPDATE,
    data
    }
};

export const clientImportAction = (data) => {
    return {
    type: types.CLIENT_IMPORT,
    data
    }
};

export const clientImportQuickFileAction = (data) => {
    return {
    type: types.CLIENT_IMPORT_QUICK_FILE,
    data
    }
};

export const clientContactImportAction = (data) => {
    return {
    type: types.CLIENT_CONTACT_IMPORT,
    data
    }
};

export const clientProfileActiveTabAction = (data) => {
    return {
    type: types.CLIENT_PROFILE_TAB_ACTIVE, 
    data
    }
};

export const clientProfileDeactiveTabAction = (data) => {
    return {
    type: types.CLIENT_PROFILE_TAB_DEACTIVE,
    data
    }
};

export const clientGetCrewChiefBonusAction = (data) => {
    return {
    type: types.CLIENT_GET_CREW_CHIEF_BONUS,
    data
    }
}; 

export const clientUpdateCrewChiefBonusAction = (data) => {
    return {
    type: types.CLIENT_UPDATE_CREW_CHIEF_BONUS,
    data
    }
}; 

export const clientContactDeleteAction = (data) => {
    return {
    type: types.CLIENT_CONTACT_DELETE,
    data
    }
};

// TO SET ACTIVE CLIENT ID FROM LOG LISTING WHILE CLICK ON CLIENT NAME 
export const clientListSetSliderClientId = (data) => {
    return {
        type: types.CLIENT_LIST_SLIDER_CLIENTID,
        data
    }
}; 

export const clientCategoryList = (data) => {
    return {
        type: types.PROFILE_CLIENT_CATEGORY_LIST,
        data
    }
};

export const ClientListForCategories = (data) =>{
    return {
        type: types.CLIENT_LIST_FOR_CATEGORIES,
        data
    }

};

export const clientFullList = (data) =>{
    return {
        type: types.CLIENT_FULL_LIST,
        data
    }

};

export const getCompanyBasicInfo = (data) =>{
    return {
        type: types.CLIENT_COMPANY_BASIC_INFO,
        data
    }
};

export const clientDepartmentsByClientIdAction = (data) => {  
    return {
        type: types.CLIENT_DEPARTMENTS_LIST,
        data
    }
};